import { render } from "./TrackingColumnReceived.vue?vue&type=template&id=d78acf4c"
import script from "./TrackingColumnReceived.vue?vue&type=script&lang=js"
export * from "./TrackingColumnReceived.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__